<template>
  <div style="">
        <v-layout class="hidden-sm-and-down">
          <v-flex xs4>
            <div class="pa-3" style="width: 100%;
                                    height: 100%;
                                    display: table;
                                    text-align:justify" >
              <p v-if="swiper" class="artefactDescription"> {{gLang[lang].home.quoteFeatured}} </p>
            </div>
          </v-flex>
          <v-flex xs8>
            <swiper class="" :options="swiperOption" ref="mySwiperA" >
           
            <swiper-slide v-for="(artefact,i) in artefacts" :key="i" v-if="i<5">
                <web-artefact-card  :artefact='artefact' :clickImage="false"></web-artefact-card>
            </swiper-slide> 

            <div class="swiper-pagination " slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>

            </swiper>
          </v-flex>
        </v-layout>

        <div class="hidden-md-and-up">

          <v-layout row>
            <v-flex x12>
            <div class="pa-3" style="width: 100%;
                                    height: 100%;
                                    display: table;
                                    text-align:justify" >
              <p v-if="swiper" class="artefactDescription"> {{ previewArtefact  }} </p>
            </div>
          </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
            <swiper class="hidden-sm-only" :options="swiperOption1" ref="mySwiperA" >
           
            <swiper-slide v-for="(artefact,i) in artefacts" :key="i" v-if="i<5">
                <web-artefact-card  :artefact='artefact' :clickImage="false"></web-artefact-card>
            </swiper-slide> 

            <div class="swiper-pagination " slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>

            </swiper>




            <swiper class="hidden-xs-only" :options="swiperOption2" ref="mySwiperA" >
           
            <swiper-slide v-for="(artefact,i) in artefacts" :key="i" v-if="i<5">
                <web-artefact-card  :artefact='artefact' :clickImage="true"></web-artefact-card>
            </swiper-slide> 

            <div class="swiper-pagination " slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>

            </swiper>
          </v-flex>
          </v-layout>
          
          
        </div>
       
  </div>
</template>




<script>
import "@/../static/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      previewArtefact: "",
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption1: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption2: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        centeredSlides: false,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiper: null
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    users() {
      return this.$store.getters.loadUsers;
    },
    description() {
      var artefact = document.getElementsByClassName("swiper-slide-active");
    }
  },
  mounted() {
    this.swiper = this.$refs.mySwiperA.swiper;
  }
};
</script>

<style src='@/../static/swiper.css'>

</style>


<style scoped>
.swiper-container {
  height: auto !important;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  height: auto;
}

.swiper-button-next {
  z-index: 9999;
}
.artefactDescription {
  display: table-cell;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/SimpleDescriptionSwiper.vue